import * as types from '../types';
import {getIdFromFilterType} from '../helper';

const state = {
    attribute: [],
    feature: [],
    checked: {
        attribute: [],
        feature: []
    }
};

const getters = {
    /**
     *
     * @param state
     * @returns {Function}
     */
    [types.GET_FILTER_BY_ID]: (state) => (id, type) => {
        if (type === 'attribute') {
            return state.attribute[id];
        }

        return state.feature[id];
    },
    /**
     *
     * @param state
     * @returns {*}
     */
    [types.GET_FILTER_FEATURES]: (state) => {
        return state.feature;
    },
    /**
     *
     * @param state
     * @returns {*}
     */
    [types.GET_FILTER_ATTRIBUTES]: (state) => {
        return state.attribute;
    },
    /**
     *
     * @param attribute
     * @returns {function(*=): null}
     */
    [types.GET_VALUES_ATTRIBUTES]: ({attribute}) => (id) => {
        const item = attribute.find((item) => item.idParent === parseInt(id));

        return item ? item.values : null;
    },
    /**
     *
     * @param feature
     * @returns {function(*=): null}
     */
    [types.GET_VALUE_FEATURES]: ({feature}) => (id) => {
        const item = feature.find((item) => item.idParent === parseInt(id));

        return item ? item.values : null;
    }
};


const actions = {

    /**
     *
     * @param commit
     * @param id
     * @param type
     */
    [types.TOGGLE_FILTER]: ({commit, dispatch}, {id, idParent, type}) => {
        const typeCheckedArray = state['checked'][type];
        const filterChecked = typeCheckedArray.find(item => getIdFromFilterType(item) === parseInt(id));
        if (filterChecked) {
            dispatch(types.DELETE_FILTER_CHECKED, {typeCheckedArray, item: filterChecked, type})
        } else {
            dispatch(types.ADD_FILTER_CHECKED, {id, idParent, type})
        }
        dispatch(types.UPDATE_PRODUCT_RESULT);
    },
    /**
     *
     * @param commit
     * @param dispatch
     * @param id
     * @param idParent
     * @param type
     */
    [types.ADD_FILTER_CHECKED]: ({commit, dispatch}, {id, idParent, type}) => {
        const filterParent = state[type].find(item => item.id === idParent);
        if (filterParent) {
            const filter = filterParent.values.find(item => getIdFromFilterType(item) === parseInt(id));
            if (filter) {
                filter.idParent = idParent;
                commit(types.MUTATE_ADD_FILTER_CHECKED, {filter, type});
            }
        }
    },
    /**
     *
     * @param commit
     * @param dispatch
     * @param typeCheckedArray
     * @param item
     */
    [types.DELETE_FILTER_CHECKED]: ({commit, dispatch}, values) => {
        commit(types.MUTATE_DELETE_FILTER_CHECKED, values);
    }
};

const mutations = {
    /**
     * Toggle filter
     *
     * @param state
     * @param id
     */
    [types.MUTATE_ADD_FILTER_CHECKED]: (state, {filter, type}) => {
        state['checked'][type].push(filter);
    },
    /**
     *
     * @param state
     * @param values
     * @param type
     * @param idParent
     * @param value
     */
    [types.MUTATE_INIT_FILTER_VALUE]: (state, {values, type, id, name}) => {
        state[type].push({
            'id': id,
            'name': name,
            'values': values
        });
    },
    /**
     *
     * @param commit
     * @param dispatch
     * @param typeCheckedArray
     * @param item
     */
    [types.MUTATE_DELETE_FILTER_CHECKED]: ({commit, dispatch}, {typeCheckedArray, item, type}) => {
        state['checked'][type] = typeCheckedArray.filter(el => el !== item);
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/filters.js